import React from 'react'
import { Modal } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
const modalErrAuto = (props) => {
  const language = getCookie('lang')
  const word = lang[language]
  const { visible, setVisible, err_type } = props
  // err_type.status err_type.configDate
  const word_err = () => {
    // case can not auto
    // status , overlap date , working day
    if (!err_type.status && !err_type.configDate && !err_type.working_day) {
      return <h4>{word['des_err_status_overlap_working_day']}</h4>
    }
    //status , overlap date
    else if (!err_type.status && !err_type.configDate && err_type.working_day) {
      return <h4>{word['des_err_status_overlap']}</h4>
    }
    // status , working day
    else if (!err_type.status && err_type.configDate && !err_type.working_day) {
      return <h4>{word['des_err_status_working_day']}</h4>
    }
    // overlap date , working day
    else if (err_type.status && !err_type.configDate && !err_type.working_day) {
      return <h4>{word['des_err_overlap_working_day']}</h4>
    }
    // status
    else if (!err_type.status && err_type.configDate && err_type.working_day) {
      return <h4>{word['des_err_status_auto']}</h4>
    }
    // overlap date
    else if (err_type.status && !err_type.configDate && err_type.working_day) {
      return <h4>{word['des_err_overlap_auto']}</h4>
    }
    // working day
    else if (err_type.status && err_type.configDate && !err_type.working_day) {
      return <h4>{word['des_err_working_day']}</h4>
    }
    // error flow
    else {
      return <h4>{word['des_err_flow']}</h4>
    }
  }
  return (
    <Modal
      className="ModalStatusOption"
      visible={visible}
      okText={'OK'}
      onOk={() => setVisible(false)}
      cancelButtonProps={{ hidden: true }}
      onCancel={() => setVisible(false)}
      destroyOnClose
      maskClosable={false}
    >
      <CloseCircleOutlined className="CloseCircleOutlined" />
      <h2>{word['title_err_auto']}</h2>
      {word_err()}
    </Modal>
  )
}

export default modalErrAuto
